import { Enum, Id, Optional, text } from '@thisisagile/easy';

export class Locale extends Enum {
  static readonly AF = new Locale('af', 'Afrikaans');
  static readonly AF_NA = new Locale('af_NA', 'Afrikaans (Namibia)');
  static readonly AF_ZA = new Locale('af_ZA', 'Afrikaans (South Africa)');
  static readonly AK = new Locale('ak', 'Akan');
  static readonly AK_GH = new Locale('ak_GH', 'Akan (Ghana)');
  static readonly SQ = new Locale('sq', 'Albanian');
  static readonly SQ_AL = new Locale('sq_AL', 'Albanian (Albania)');
  static readonly SQ_XK = new Locale('sq_XK', 'Albanian (Kosovo)');
  static readonly SQ_MK = new Locale('sq_MK', 'Albanian (Macedonia)');
  static readonly AM = new Locale('am', 'Amharic');
  static readonly AM_ET = new Locale('am_ET', 'Amharic (Ethiopia)');
  static readonly AR = new Locale('ar', 'Arabic');
  static readonly AR_DZ = new Locale('ar_DZ', 'Arabic (Algeria)');
  static readonly AR_BH = new Locale('ar_BH', 'Arabic (Bahrain)');
  static readonly AR_TD = new Locale('ar_TD', 'Arabic (Chad)');
  static readonly AR_KM = new Locale('ar_KM', 'Arabic (Comoros)');
  static readonly AR_DJ = new Locale('ar_DJ', 'Arabic (Djibouti)');
  static readonly AR_EG = new Locale('ar_EG', 'Arabic (Egypt)');
  static readonly AR_ER = new Locale('ar_ER', 'Arabic (Eritrea)');
  static readonly AR_IQ = new Locale('ar_IQ', 'Arabic (Iraq)');
  static readonly AR_IL = new Locale('ar_IL', 'Arabic (Israel)');
  static readonly AR_JO = new Locale('ar_JO', 'Arabic (Jordan)');
  static readonly AR_KW = new Locale('ar_KW', 'Arabic (Kuwait)');
  static readonly AR_LB = new Locale('ar_LB', 'Arabic (Lebanon)');
  static readonly AR_LY = new Locale('ar_LY', 'Arabic (Libya)');
  static readonly AR_MR = new Locale('ar_MR', 'Arabic (Mauritania)');
  static readonly AR_MA = new Locale('ar_MA', 'Arabic (Morocco)');
  static readonly AR_OM = new Locale('ar_OM', 'Arabic (Oman)');
  static readonly AR_PS = new Locale('ar_PS', 'Arabic (Palestinian Territories)');
  static readonly AR_QA = new Locale('ar_QA', 'Arabic (Qatar)');
  static readonly AR_SA = new Locale('ar_SA', 'Arabic (Saudi Arabia)');
  static readonly AR_SO = new Locale('ar_SO', 'Arabic (Somalia)');
  static readonly AR_SS = new Locale('ar_SS', 'Arabic (South Sudan)');
  static readonly AR_SD = new Locale('ar_SD', 'Arabic (Sudan)');
  static readonly AR_SY = new Locale('ar_SY', 'Arabic (Syria)');
  static readonly AR_TN = new Locale('ar_TN', 'Arabic (Tunisia)');
  static readonly AR_AE = new Locale('ar_AE', 'Arabic (United Arab Emirates)');
  static readonly AR_EH = new Locale('ar_EH', 'Arabic (Western Sahara)');
  static readonly AR_YE = new Locale('ar_YE', 'Arabic (Yemen)');
  static readonly HY = new Locale('hy', 'Armenian');
  static readonly HY_AM = new Locale('hy_AM', 'Armenian (Armenia)');
  static readonly AS = new Locale('as', 'Assamese');
  static readonly AS_IN = new Locale('as_IN', 'Assamese (India)');
  static readonly AZ = new Locale('az', 'Azerbaijani');
  static readonly AZ_AZ = new Locale('az_AZ', 'Azerbaijani (Azerbaijan)');
  static readonly AZ_CYRL_AZ = new Locale('az_Cyrl_AZ', 'Azerbaijani (Cyrillic, Azerbaijan)');
  static readonly AZ_CYRL = new Locale('az_Cyrl', 'Azerbaijani (Cyrillic)', 'az');
  static readonly AZ_LATN_AZ = new Locale('az_Latn_AZ', 'Azerbaijani (Latin, Azerbaijan)');
  static readonly AZ_LATN = new Locale('az_Latn', 'Azerbaijani (Latin)', 'az');
  static readonly BM = new Locale('bm', 'Bambara');
  static readonly BM_LATN_ML = new Locale('bm_Latn_ML', 'Bambara (Latin, Mali)');
  static readonly BM_LATN = new Locale('bm_Latn', 'Bambara (Latin)', 'bm');
  static readonly EU = new Locale('eu', 'Basque');
  static readonly EU_ES = new Locale('eu_ES', 'Basque (Spain)');
  static readonly BE = new Locale('be', 'Belarusian');
  static readonly BE_BY = new Locale('be_BY', 'Belarusian (Belarus)');
  static readonly BN = new Locale('bn', 'Bengali');
  static readonly BN_BD = new Locale('bn_BD', 'Bengali (Bangladesh)');
  static readonly BN_IN = new Locale('bn_IN', 'Bengali (India)');
  static readonly BS = new Locale('bs', 'Bosnian');
  static readonly BS_BA = new Locale('bs_BA', 'Bosnian (Bosnia & Herzegovina)');
  static readonly BS_CYRL_BA = new Locale('bs_Cyrl_BA', 'Bosnian (Cyrillic, Bosnia & Herzegovina)');
  static readonly BS_CYRL = new Locale('bs_Cyrl', 'Bosnian (Cyrillic)', 'bs');
  static readonly BS_LATN_BA = new Locale('bs_Latn_BA', 'Bosnian (Latin, Bosnia & Herzegovina)');
  static readonly BS_LATN = new Locale('bs_Latn', 'Bosnian (Latin)', 'bs');
  static readonly BR = new Locale('br', 'Breton');
  static readonly BR_FR = new Locale('br_FR', 'Breton (France)');
  static readonly BG = new Locale('bg', 'Bulgarian');
  static readonly BG_BG = new Locale('bg_BG', 'Bulgarian (Bulgaria)');
  static readonly MY = new Locale('my', 'Burmese');
  static readonly MY_MM = new Locale('my_MM', 'Burmese (Myanmar (Burma))');
  static readonly CA = new Locale('ca', 'Catalan');
  static readonly CA_AD = new Locale('ca_AD', 'Catalan (Andorra)');
  static readonly CA_FR = new Locale('ca_FR', 'Catalan (France)');
  static readonly CA_IT = new Locale('ca_IT', 'Catalan (Italy)');
  static readonly CA_ES = new Locale('ca_ES', 'Catalan (Spain)');
  static readonly ZH = new Locale('zh', 'Chinese');
  static readonly ZH_CN = new Locale('zh_CN', 'Chinese (China)');
  static readonly ZH_HK = new Locale('zh_HK', 'Chinese (Hong Kong SAR China)');
  static readonly ZH_MO = new Locale('zh_MO', 'Chinese (Macau SAR China)');
  static readonly ZH_HANS_CN = new Locale('zh_Hans_CN', 'Chinese (Simplified, China)');
  static readonly ZH_HANS_HK = new Locale('zh_Hans_HK', 'Chinese (Simplified, Hong Kong SAR China)');
  static readonly ZH_HANS_MO = new Locale('zh_Hans_MO', 'Chinese (Simplified, Macau SAR China)');
  static readonly ZH_HANS_SG = new Locale('zh_Hans_SG', 'Chinese (Simplified, Singapore)');
  static readonly ZH_HANS = new Locale('zh_Hans', 'Chinese (Simplified)');
  static readonly ZH_SG = new Locale('zh_SG', 'Chinese (Singapore)');
  static readonly ZH_TW = new Locale('zh_TW', 'Chinese (Taiwan)');
  static readonly ZH_HANT_HK = new Locale('zh_Hant_HK', 'Chinese (Traditional, Hong Kong SAR China)');
  static readonly ZH_HANT_MO = new Locale('zh_Hant_MO', 'Chinese (Traditional, Macau SAR China)');
  static readonly ZH_HANT_TW = new Locale('zh_Hant_TW', 'Chinese (Traditional, Taiwan)');
  static readonly ZH_HANT = new Locale('zh_Hant', 'Chinese (Traditional)');
  static readonly KW = new Locale('kw', 'Cornish');
  static readonly KW_GB = new Locale('kw_GB', 'Cornish (United Kingdom)');
  static readonly HR = new Locale('hr', 'Croatian');
  static readonly HR_BA = new Locale('hr_BA', 'Croatian (Bosnia & Herzegovina)');
  static readonly HR_HR = new Locale('hr_HR', 'Croatian (Croatia)');
  static readonly CS = new Locale('cs', 'Czech');
  static readonly CS_CZ = new Locale('cs_CZ', 'Czech (Czech Republic)');
  static readonly DA = new Locale('da', 'Danish');
  static readonly DA_DK = new Locale('da_DK', 'Danish (Denmark)');
  static readonly DA_GL = new Locale('da_GL', 'Danish (Greenland)');
  static readonly NL = new Locale('nl', 'Dutch');
  static readonly NL_AW = new Locale('nl_AW', 'Dutch (Aruba)');
  static readonly NL_BE = new Locale('nl_BE', 'Dutch (Belgium)');
  static readonly NL_BQ = new Locale('nl_BQ', 'Dutch (Caribbean Netherlands)');
  static readonly NL_CW = new Locale('nl_CW', 'Dutch (Curaçao)');
  static readonly NL_NL = new Locale('nl_NL', 'Dutch (Netherlands)');
  static readonly NL_SX = new Locale('nl_SX', 'Dutch (Sint Maarten)');
  static readonly NL_SR = new Locale('nl_SR', 'Dutch (Suriname)');
  static readonly DZ = new Locale('dz', 'Dzongkha');
  static readonly DZ_BT = new Locale('dz_BT', 'Dzongkha (Bhutan)');
  static readonly EN = new Locale('en', 'English', 'gb');
  static readonly EN_AS = new Locale('en_AS', 'English (American Samoa)');
  static readonly EN_AI = new Locale('en_AI', 'English (Anguilla)');
  static readonly EN_AG = new Locale('en_AG', 'English (Antigua & Barbuda)');
  static readonly EN_AU = new Locale('en_AU', 'English (Australia)');
  static readonly EN_BS = new Locale('en_BS', 'English (Bahamas)');
  static readonly EN_BB = new Locale('en_BB', 'English (Barbados)');
  static readonly EN_BE = new Locale('en_BE', 'English (Belgium)');
  static readonly EN_BZ = new Locale('en_BZ', 'English (Belize)');
  static readonly EN_BM = new Locale('en_BM', 'English (Bermuda)');
  static readonly EN_BW = new Locale('en_BW', 'English (Botswana)');
  static readonly EN_IO = new Locale('en_IO', 'English (British Indian Ocean Territory)');
  static readonly EN_VG = new Locale('en_VG', 'English (British Virgin Islands)');
  static readonly EN_CM = new Locale('en_CM', 'English (Cameroon)');
  static readonly EN_CA = new Locale('en_CA', 'English (Canada)');
  static readonly EN_KY = new Locale('en_KY', 'English (Cayman Islands)');
  static readonly EN_CX = new Locale('en_CX', 'English (Christmas Island)');
  static readonly EN_CC = new Locale('en_CC', 'English (Cocos (Keeling) Islands)');
  static readonly EN_CK = new Locale('en_CK', 'English (Cook Islands)');
  static readonly EN_DG = new Locale('en_DG', 'English (Diego Garcia)');
  static readonly EN_DM = new Locale('en_DM', 'English (Dominica)');
  static readonly EN_ER = new Locale('en_ER', 'English (Eritrea)');
  static readonly EN_FK = new Locale('en_FK', 'English (Falkland Islands)');
  static readonly EN_FJ = new Locale('en_FJ', 'English (Fiji)');
  static readonly EN_GM = new Locale('en_GM', 'English (Gambia)');
  static readonly EN_GH = new Locale('en_GH', 'English (Ghana)');
  static readonly EN_GI = new Locale('en_GI', 'English (Gibraltar)');
  static readonly EN_GD = new Locale('en_GD', 'English (Grenada)');
  static readonly EN_GU = new Locale('en_GU', 'English (Guam)');
  static readonly EN_GG = new Locale('en_GG', 'English (Guernsey)');
  static readonly EN_GY = new Locale('en_GY', 'English (Guyana)');
  static readonly EN_HK = new Locale('en_HK', 'English (Hong Kong SAR China)');
  static readonly EN_IN = new Locale('en_IN', 'English (India)');
  static readonly EN_IE = new Locale('en_IE', 'English (Ireland)');
  static readonly EN_IM = new Locale('en_IM', 'English (Isle of Man)');
  static readonly EN_JM = new Locale('en_JM', 'English (Jamaica)');
  static readonly EN_JE = new Locale('en_JE', 'English (Jersey)');
  static readonly EN_KE = new Locale('en_KE', 'English (Kenya)');
  static readonly EN_KI = new Locale('en_KI', 'English (Kiribati)');
  static readonly EN_LS = new Locale('en_LS', 'English (Lesotho)');
  static readonly EN_LR = new Locale('en_LR', 'English (Liberia)');
  static readonly EN_MO = new Locale('en_MO', 'English (Macau SAR China)');
  static readonly EN_MG = new Locale('en_MG', 'English (Madagascar)');
  static readonly EN_MW = new Locale('en_MW', 'English (Malawi)');
  static readonly EN_MY = new Locale('en_MY', 'English (Malaysia)');
  static readonly EN_MT = new Locale('en_MT', 'English (Malta)');
  static readonly EN_MH = new Locale('en_MH', 'English (Marshall Islands)');
  static readonly EN_MU = new Locale('en_MU', 'English (Mauritius)');
  static readonly EN_FM = new Locale('en_FM', 'English (Micronesia)');
  static readonly EN_MS = new Locale('en_MS', 'English (Montserrat)');
  static readonly EN_NA = new Locale('en_NA', 'English (Namibia)');
  static readonly EN_NR = new Locale('en_NR', 'English (Nauru)');
  static readonly EN_NZ = new Locale('en_NZ', 'English (New Zealand)');
  static readonly EN_NG = new Locale('en_NG', 'English (Nigeria)');
  static readonly EN_NU = new Locale('en_NU', 'English (Niue)');
  static readonly EN_NF = new Locale('en_NF', 'English (Norfolk Island)');
  static readonly EN_MP = new Locale('en_MP', 'English (Northern Mariana Islands)');
  static readonly EN_PK = new Locale('en_PK', 'English (Pakistan)');
  static readonly EN_PW = new Locale('en_PW', 'English (Palau)');
  static readonly EN_PG = new Locale('en_PG', 'English (Papua New Guinea)');
  static readonly EN_PH = new Locale('en_PH', 'English (Philippines)');
  static readonly EN_PN = new Locale('en_PN', 'English (Pitcairn Islands)');
  static readonly EN_PR = new Locale('en_PR', 'English (Puerto Rico)');
  static readonly EN_RW = new Locale('en_RW', 'English (Rwanda)');
  static readonly EN_WS = new Locale('en_WS', 'English (Samoa)');
  static readonly EN_SC = new Locale('en_SC', 'English (Seychelles)');
  static readonly EN_SL = new Locale('en_SL', 'English (Sierra Leone)');
  static readonly EN_SG = new Locale('en_SG', 'English (Singapore)');
  static readonly EN_SX = new Locale('en_SX', 'English (Sint Maarten)');
  static readonly EN_SB = new Locale('en_SB', 'English (Solomon Islands)');
  static readonly EN_ZA = new Locale('en_ZA', 'English (South Africa)');
  static readonly EN_SS = new Locale('en_SS', 'English (South Sudan)');
  static readonly EN_SH = new Locale('en_SH', 'English (St. Helena)');
  static readonly EN_KN = new Locale('en_KN', 'English (St. Kitts & Nevis)');
  static readonly EN_LC = new Locale('en_LC', 'English (St. Lucia)');
  static readonly EN_VC = new Locale('en_VC', 'English (St. Vincent & Grenadines)');
  static readonly EN_SD = new Locale('en_SD', 'English (Sudan)');
  static readonly EN_SZ = new Locale('en_SZ', 'English (Swaziland)');
  static readonly EN_TZ = new Locale('en_TZ', 'English (Tanzania)');
  static readonly EN_TK = new Locale('en_TK', 'English (Tokelau)');
  static readonly EN_TO = new Locale('en_TO', 'English (Tonga)');
  static readonly EN_TT = new Locale('en_TT', 'English (Trinidad & Tobago)');
  static readonly EN_TC = new Locale('en_TC', 'English (Turks & Caicos Islands)');
  static readonly EN_TV = new Locale('en_TV', 'English (Tuvalu)');
  static readonly EN_UM = new Locale('en_UM', 'English (U.S. Outlying Islands)');
  static readonly EN_VI = new Locale('en_VI', 'English (U.S. Virgin Islands)');
  static readonly EN_UG = new Locale('en_UG', 'English (Uganda)');
  static readonly EN_GB = new Locale('en_GB', 'English (United Kingdom)');
  static readonly EN_US = new Locale('en_US', 'English (United States)');
  static readonly EN_VU = new Locale('en_VU', 'English (Vanuatu)');
  static readonly EN_ZM = new Locale('en_ZM', 'English (Zambia)');
  static readonly EN_ZW = new Locale('en_ZW', 'English (Zimbabwe)');
  static readonly EO = new Locale('eo', 'Esperanto');
  static readonly ET = new Locale('et', 'Estonian');
  static readonly ET_EE = new Locale('et_EE', 'Estonian (Estonia)');
  static readonly EE = new Locale('ee', 'Ewe');
  static readonly EE_GH = new Locale('ee_GH', 'Ewe (Ghana)');
  static readonly EE_TG = new Locale('ee_TG', 'Ewe (Togo)');
  static readonly FO = new Locale('fo', 'Faroese');
  static readonly FO_FO = new Locale('fo_FO', 'Faroese (Faroe Islands)');
  static readonly FI = new Locale('fi', 'Finnish');
  static readonly FI_FI = new Locale('fi_FI', 'Finnish (Finland)');
  static readonly FR = new Locale('fr', 'French');
  static readonly FR_DZ = new Locale('fr_DZ', 'French (Algeria)');
  static readonly FR_BE = new Locale('fr_BE', 'French (Belgium)');
  static readonly FR_BJ = new Locale('fr_BJ', 'French (Benin)');
  static readonly FR_BF = new Locale('fr_BF', 'French (Burkina Faso)');
  static readonly FR_BI = new Locale('fr_BI', 'French (Burundi)');
  static readonly FR_CM = new Locale('fr_CM', 'French (Cameroon)');
  static readonly FR_CA = new Locale('fr_CA', 'French (Canada)');
  static readonly FR_CF = new Locale('fr_CF', 'French (Central African Republic)');
  static readonly FR_TD = new Locale('fr_TD', 'French (Chad)');
  static readonly FR_KM = new Locale('fr_KM', 'French (Comoros)');
  static readonly FR_CG = new Locale('fr_CG', 'French (Congo - Brazzaville)');
  static readonly FR_CD = new Locale('fr_CD', 'French (Congo - Kinshasa)');
  static readonly FR_CI = new Locale('fr_CI', 'French (Côte d’Ivoire)');
  static readonly FR_DJ = new Locale('fr_DJ', 'French (Djibouti)');
  static readonly FR_GQ = new Locale('fr_GQ', 'French (Equatorial Guinea)');
  static readonly FR_FR = new Locale('fr_FR', 'French (France)');
  static readonly FR_GF = new Locale('fr_GF', 'French (French Guiana)');
  static readonly FR_PF = new Locale('fr_PF', 'French (French Polynesia)');
  static readonly FR_GA = new Locale('fr_GA', 'French (Gabon)');
  static readonly FR_GP = new Locale('fr_GP', 'French (Guadeloupe)');
  static readonly FR_GN = new Locale('fr_GN', 'French (Guinea)');
  static readonly FR_HT = new Locale('fr_HT', 'French (Haiti)');
  static readonly FR_LU = new Locale('fr_LU', 'French (Luxembourg)');
  static readonly FR_MG = new Locale('fr_MG', 'French (Madagascar)');
  static readonly FR_ML = new Locale('fr_ML', 'French (Mali)');
  static readonly FR_MQ = new Locale('fr_MQ', 'French (Martinique)');
  static readonly FR_MR = new Locale('fr_MR', 'French (Mauritania)');
  static readonly FR_MU = new Locale('fr_MU', 'French (Mauritius)');
  static readonly FR_YT = new Locale('fr_YT', 'French (Mayotte)');
  static readonly FR_MC = new Locale('fr_MC', 'French (Monaco)');
  static readonly FR_MA = new Locale('fr_MA', 'French (Morocco)');
  static readonly FR_NC = new Locale('fr_NC', 'French (New Caledonia)');
  static readonly FR_NE = new Locale('fr_NE', 'French (Niger)');
  static readonly FR_RE = new Locale('fr_RE', 'French (Réunion)');
  static readonly FR_RW = new Locale('fr_RW', 'French (Rwanda)');
  static readonly FR_SN = new Locale('fr_SN', 'French (Senegal)');
  static readonly FR_SC = new Locale('fr_SC', 'French (Seychelles)');
  static readonly FR_BL = new Locale('fr_BL', 'French (St. Barthélemy)');
  static readonly FR_MF = new Locale('fr_MF', 'French (St. Martin)');
  static readonly FR_PM = new Locale('fr_PM', 'French (St. Pierre & Miquelon)');
  static readonly FR_CH = new Locale('fr_CH', 'French (Switzerland)');
  static readonly FR_SY = new Locale('fr_SY', 'French (Syria)');
  static readonly FR_TG = new Locale('fr_TG', 'French (Togo)');
  static readonly FR_TN = new Locale('fr_TN', 'French (Tunisia)');
  static readonly FR_VU = new Locale('fr_VU', 'French (Vanuatu)');
  static readonly FR_WF = new Locale('fr_WF', 'French (Wallis & Futuna)');
  static readonly FF = new Locale('ff', 'Fulah');
  static readonly FF_CM = new Locale('ff_CM', 'Fulah (Cameroon)');
  static readonly FF_GN = new Locale('ff_GN', 'Fulah (Guinea)');
  static readonly FF_MR = new Locale('ff_MR', 'Fulah (Mauritania)');
  static readonly FF_SN = new Locale('ff_SN', 'Fulah (Senegal)');
  static readonly GL = new Locale('gl', 'Galician');
  static readonly GL_ES = new Locale('gl_ES', 'Galician (Spain)');
  static readonly LG = new Locale('lg', 'Ganda');
  static readonly LG_UG = new Locale('lg_UG', 'Ganda (Uganda)');
  static readonly KA = new Locale('ka', 'Georgian');
  static readonly KA_GE = new Locale('ka_GE', 'Georgian (Georgia)');
  static readonly DE = new Locale('de', 'German');
  static readonly DE_AT = new Locale('de_AT', 'German (Austria)');
  static readonly DE_BE = new Locale('de_BE', 'German (Belgium)');
  static readonly DE_DE = new Locale('de_DE', 'German (Germany)');
  static readonly DE_LI = new Locale('de_LI', 'German (Liechtenstein)');
  static readonly DE_LU = new Locale('de_LU', 'German (Luxembourg)');
  static readonly DE_CH = new Locale('de_CH', 'German (Switzerland)');
  static readonly EL = new Locale('el', 'Greek');
  static readonly EL_CY = new Locale('el_CY', 'Greek (Cyprus)');
  static readonly EL_GR = new Locale('el_GR', 'Greek (Greece)');
  static readonly GU = new Locale('gu', 'Gujarati');
  static readonly GU_IN = new Locale('gu_IN', 'Gujarati (India)');
  static readonly HA = new Locale('ha', 'Hausa');
  static readonly HA_GH = new Locale('ha_GH', 'Hausa (Ghana)');
  static readonly HA_LATN_GH = new Locale('ha_Latn_GH', 'Hausa (Latin, Ghana)');
  static readonly HA_LATN_NE = new Locale('ha_Latn_NE', 'Hausa (Latin, Niger)');
  static readonly HA_LATN_NG = new Locale('ha_Latn_NG', 'Hausa (Latin, Nigeria)');
  static readonly HA_LATN = new Locale('ha_Latn', 'Hausa (Latin)');
  static readonly HA_NE = new Locale('ha_NE', 'Hausa (Niger)');
  static readonly HA_NG = new Locale('ha_NG', 'Hausa (Nigeria)');
  static readonly HE = new Locale('he', 'Hebrew');
  static readonly HE_IL = new Locale('he_IL', 'Hebrew (Israel)');
  static readonly HI = new Locale('hi', 'Hindi');
  static readonly HI_IN = new Locale('hi_IN', 'Hindi (India)');
  static readonly HU = new Locale('hu', 'Hungarian');
  static readonly HU_HU = new Locale('hu_HU', 'Hungarian (Hungary)');
  static readonly IS = new Locale('is', 'Icelandic');
  static readonly IS_IS = new Locale('is_IS', 'Icelandic (Iceland)');
  static readonly IG = new Locale('ig', 'Igbo');
  static readonly IG_NG = new Locale('ig_NG', 'Igbo (Nigeria)');
  static readonly ID = new Locale('id', 'Indonesian');
  static readonly ID_ID = new Locale('id_ID', 'Indonesian (Indonesia)');
  static readonly GA = new Locale('ga', 'Irish');
  static readonly GA_IE = new Locale('ga_IE', 'Irish (Ireland)');
  static readonly IT = new Locale('it', 'Italian');
  static readonly IT_IT = new Locale('it_IT', 'Italian (Italy)');
  static readonly IT_SM = new Locale('it_SM', 'Italian (San Marino)');
  static readonly IT_CH = new Locale('it_CH', 'Italian (Switzerland)');
  static readonly JA = new Locale('ja', 'Japanese');
  static readonly JA_JP = new Locale('ja_JP', 'Japanese (Japan)');
  static readonly KL = new Locale('kl', 'Kalaallisut');
  static readonly KL_GL = new Locale('kl_GL', 'Kalaallisut (Greenland)');
  static readonly KN = new Locale('kn', 'Kannada');
  static readonly KN_IN = new Locale('kn_IN', 'Kannada (India)');
  static readonly KS = new Locale('ks', 'Kashmiri');
  static readonly KS_ARAB_IN = new Locale('ks_Arab_IN', 'Kashmiri (Arabic, India)');
  static readonly KS_ARAB = new Locale('ks_Arab', 'Kashmiri (Arabic)', 'ks');
  static readonly KS_IN = new Locale('ks_IN', 'Kashmiri (India)');
  static readonly KK = new Locale('kk', 'Kazakh');
  static readonly KK_CYRL_KZ = new Locale('kk_Cyrl_KZ', 'Kazakh (Cyrillic, Kazakhstan)');
  static readonly KK_CYRL = new Locale('kk_Cyrl', 'Kazakh (Cyrillic)', 'kk');
  static readonly KK_KZ = new Locale('kk_KZ', 'Kazakh (Kazakhstan)');
  static readonly KM = new Locale('km', 'Khmer');
  static readonly KM_KH = new Locale('km_KH', 'Khmer (Cambodia)');
  static readonly KI = new Locale('ki', 'Kikuyu');
  static readonly KI_KE = new Locale('ki_KE', 'Kikuyu (Kenya)');
  static readonly RW = new Locale('rw', 'Kinyarwanda');
  static readonly RW_RW = new Locale('rw_RW', 'Kinyarwanda (Rwanda)');
  static readonly KO = new Locale('ko', 'Korean');
  static readonly KO_KP = new Locale('ko_KP', 'Korean (North Korea)');
  static readonly KO_KR = new Locale('ko_KR', 'Korean (South Korea)');
  static readonly KY = new Locale('ky', 'Kyrgyz');
  static readonly KY_CYRL_KG = new Locale('ky_Cyrl_KG', 'Kyrgyz (Cyrillic, Kyrgyzstan)');
  static readonly KY_CYRL = new Locale('ky_Cyrl', 'Kyrgyz (Cyrillic)', 'ky');
  static readonly KY_KG = new Locale('ky_KG', 'Kyrgyz (Kyrgyzstan)');
  static readonly LO = new Locale('lo', 'Lao');
  static readonly LO_LA = new Locale('lo_LA', 'Lao (Laos)');
  static readonly LV = new Locale('lv', 'Latvian');
  static readonly LV_LV = new Locale('lv_LV', 'Latvian (Latvia)');
  static readonly LN = new Locale('ln', 'Lingala');
  static readonly LN_AO = new Locale('ln_AO', 'Lingala (Angola)');
  static readonly LN_CF = new Locale('ln_CF', 'Lingala (Central African Republic)');
  static readonly LN_CG = new Locale('ln_CG', 'Lingala (Congo - Brazzaville)');
  static readonly LN_CD = new Locale('ln_CD', 'Lingala (Congo - Kinshasa)');
  static readonly LT = new Locale('lt', 'Lithuanian');
  static readonly LT_LT = new Locale('lt_LT', 'Lithuanian (Lithuania)');
  static readonly LU = new Locale('lu', 'Luba-Katanga');
  static readonly LU_CD = new Locale('lu_CD', 'Luba-Katanga (Congo - Kinshasa)');
  static readonly LB = new Locale('lb', 'Luxembourgish');
  static readonly LB_LU = new Locale('lb_LU', 'Luxembourgish (Luxembourg)');
  static readonly MK = new Locale('mk', 'Macedonian');
  static readonly MK_MK = new Locale('mk_MK', 'Macedonian (Macedonia)');
  static readonly MG = new Locale('mg', 'Malagasy');
  static readonly MG_MG = new Locale('mg_MG', 'Malagasy (Madagascar)');
  static readonly MS = new Locale('ms', 'Malay');
  static readonly MS_BN = new Locale('ms_BN', 'Malay (Brunei)');
  static readonly MS_LATN_BN = new Locale('ms_Latn_BN', 'Malay (Latin, Brunei)');
  static readonly MS_LATN_MY = new Locale('ms_Latn_MY', 'Malay (Latin, Malaysia)');
  static readonly MS_LATN_SG = new Locale('ms_Latn_SG', 'Malay (Latin, Singapore)');
  static readonly MS_LATN = new Locale('ms_Latn', 'Malay (Latin)', 'ms');
  static readonly MS_MY = new Locale('ms_MY', 'Malay (Malaysia)');
  static readonly MS_SG = new Locale('ms_SG', 'Malay (Singapore)');
  static readonly ML = new Locale('ml', 'Malayalam');
  static readonly ML_IN = new Locale('ml_IN', 'Malayalam (India)');
  static readonly MT = new Locale('mt', 'Maltese');
  static readonly MT_MT = new Locale('mt_MT', 'Maltese (Malta)');
  static readonly GV = new Locale('gv', 'Manx');
  static readonly GV_IM = new Locale('gv_IM', 'Manx (Isle of Man)');
  static readonly MR = new Locale('mr', 'Marathi');
  static readonly MR_IN = new Locale('mr_IN', 'Marathi (India)');
  static readonly MN = new Locale('mn', 'Mongolian');
  static readonly MN_CYRL_MN = new Locale('mn_Cyrl_MN', 'Mongolian (Cyrillic, Mongolia)');
  static readonly MN_CYRL = new Locale('mn_Cyrl', 'Mongolian (Cyrillic)', 'mn');
  static readonly MN_MN = new Locale('mn_MN', 'Mongolian (Mongolia)');
  static readonly NE = new Locale('ne', 'Nepali');
  static readonly NE_IN = new Locale('ne_IN', 'Nepali (India)');
  static readonly NE_NP = new Locale('ne_NP', 'Nepali (Nepal)');
  static readonly ND = new Locale('nd', 'North Ndebele');
  static readonly ND_ZW = new Locale('nd_ZW', 'North Ndebele (Zimbabwe)');
  static readonly SE = new Locale('se', 'Northern Sami');
  static readonly SE_FI = new Locale('se_FI', 'Northern Sami (Finland)');
  static readonly SE_NO = new Locale('se_NO', 'Northern Sami (Norway)');
  static readonly SE_SE = new Locale('se_SE', 'Northern Sami (Sweden)');
  static readonly NO = new Locale('no', 'Norwegian');
  static readonly NO_NO = new Locale('no_NO', 'Norwegian (Norway)');
  static readonly NB = new Locale('nb', 'Norwegian Bokmål');
  static readonly NB_NO = new Locale('nb_NO', 'Norwegian Bokmål (Norway)');
  static readonly NB_SJ = new Locale('nb_SJ', 'Norwegian Bokmål (Svalbard & Jan Mayen)');
  static readonly NN = new Locale('nn', 'Norwegian Nynorsk');
  static readonly NN_NO = new Locale('nn_NO', 'Norwegian Nynorsk (Norway)');
  static readonly OR = new Locale('or', 'Oriya');
  static readonly OR_IN = new Locale('or_IN', 'Oriya (India)');
  static readonly OM = new Locale('om', 'Oromo');
  static readonly OM_ET = new Locale('om_ET', 'Oromo (Ethiopia)');
  static readonly OM_KE = new Locale('om_KE', 'Oromo (Kenya)');
  static readonly OS = new Locale('os', 'Ossetic');
  static readonly OS_GE = new Locale('os_GE', 'Ossetic (Georgia)');
  static readonly OS_RU = new Locale('os_RU', 'Ossetic (Russia)');
  static readonly PS = new Locale('ps', 'Pashto');
  static readonly PS_AF = new Locale('ps_AF', 'Pashto (Afghanistan)');
  static readonly FA = new Locale('fa', 'Persian');
  static readonly FA_AF = new Locale('fa_AF', 'Persian (Afghanistan)');
  static readonly FA_IR = new Locale('fa_IR', 'Persian (Iran)');
  static readonly PL = new Locale('pl', 'Polish');
  static readonly PL_PL = new Locale('pl_PL', 'Polish (Poland)');
  static readonly PT = new Locale('pt', 'Portuguese');
  static readonly PT_AO = new Locale('pt_AO', 'Portuguese (Angola)');
  static readonly PT_BR = new Locale('pt_BR', 'Portuguese (Brazil)');
  static readonly PT_CV = new Locale('pt_CV', 'Portuguese (Cape Verde)');
  static readonly PT_GW = new Locale('pt_GW', 'Portuguese (Guinea-Bissau)');
  static readonly PT_MO = new Locale('pt_MO', 'Portuguese (Macau SAR China)');
  static readonly PT_MZ = new Locale('pt_MZ', 'Portuguese (Mozambique)');
  static readonly PT_PT = new Locale('pt_PT', 'Portuguese (Portugal)');
  static readonly PT_ST = new Locale('pt_ST', 'Portuguese (São Tomé & Príncipe)');
  static readonly PT_TL = new Locale('pt_TL', 'Portuguese (Timor-Leste)');
  static readonly PA = new Locale('pa', 'Punjabi');
  static readonly PA_ARAB_PK = new Locale('pa_Arab_PK', 'Punjabi (Arabic, Pakistan)');
  static readonly PA_ARAB = new Locale('pa_Arab', 'Punjabi (Arabic)', 'pa');
  static readonly PA_GURU_IN = new Locale('pa_Guru_IN', 'Punjabi (Gurmukhi, India)');
  static readonly PA_GURU = new Locale('pa_Guru', 'Punjabi (Gurmukhi)', 'pa');
  static readonly PA_IN = new Locale('pa_IN', 'Punjabi (India)');
  static readonly PA_PK = new Locale('pa_PK', 'Punjabi (Pakistan)');
  static readonly QU = new Locale('qu', 'Quechua');
  static readonly QU_BO = new Locale('qu_BO', 'Quechua (Bolivia)');
  static readonly QU_EC = new Locale('qu_EC', 'Quechua (Ecuador)');
  static readonly QU_PE = new Locale('qu_PE', 'Quechua (Peru)');
  static readonly RO = new Locale('ro', 'Romanian');
  static readonly RO_MD = new Locale('ro_MD', 'Romanian (Moldova)');
  static readonly RO_RO = new Locale('ro_RO', 'Romanian (Romania)');
  static readonly RM = new Locale('rm', 'Romansh');
  static readonly RM_CH = new Locale('rm_CH', 'Romansh (Switzerland)');
  static readonly RN = new Locale('rn', 'Rundi');
  static readonly RN_BI = new Locale('rn_BI', 'Rundi (Burundi)');
  static readonly RU = new Locale('ru', 'Russian');
  static readonly RU_BY = new Locale('ru_BY', 'Russian (Belarus)');
  static readonly RU_KZ = new Locale('ru_KZ', 'Russian (Kazakhstan)');
  static readonly RU_KG = new Locale('ru_KG', 'Russian (Kyrgyzstan)');
  static readonly RU_MD = new Locale('ru_MD', 'Russian (Moldova)');
  static readonly RU_RU = new Locale('ru_RU', 'Russian (Russia)');
  static readonly RU_UA = new Locale('ru_UA', 'Russian (Ukraine)');
  static readonly SG = new Locale('sg', 'Sango');
  static readonly SG_CF = new Locale('sg_CF', 'Sango (Central African Republic)');
  static readonly GD = new Locale('gd', 'Scottish Gaelic');
  static readonly GD_GB = new Locale('gd_GB', 'Scottish Gaelic (United Kingdom)');
  static readonly SR = new Locale('sr', 'Serbian');
  static readonly SR_BA = new Locale('sr_BA', 'Serbian (Bosnia & Herzegovina)');
  static readonly SR_CYRL_BA = new Locale('sr_Cyrl_BA', 'Serbian (Cyrillic, Bosnia & Herzegovina)');
  static readonly SR_CYRL_XK = new Locale('sr_Cyrl_XK', 'Serbian (Cyrillic, Kosovo)');
  static readonly SR_CYRL_ME = new Locale('sr_Cyrl_ME', 'Serbian (Cyrillic, Montenegro)');
  static readonly SR_CYRL_RS = new Locale('sr_Cyrl_RS', 'Serbian (Cyrillic, Serbia)');
  static readonly SR_CYRL = new Locale('sr_Cyrl', 'Serbian (Cyrillic)', 'sr');
  static readonly SR_XK = new Locale('sr_XK', 'Serbian (Kosovo)');
  static readonly SR_LATN_BA = new Locale('sr_Latn_BA', 'Serbian (Latin, Bosnia & Herzegovina)');
  static readonly SR_LATN_XK = new Locale('sr_Latn_XK', 'Serbian (Latin, Kosovo)');
  static readonly SR_LATN_ME = new Locale('sr_Latn_ME', 'Serbian (Latin, Montenegro)');
  static readonly SR_LATN_RS = new Locale('sr_Latn_RS', 'Serbian (Latin, Serbia)');
  static readonly SR_LATN = new Locale('sr_Latn', 'Serbian (Latin)', 'sr');
  static readonly SR_ME = new Locale('sr_ME', 'Serbian (Montenegro)');
  static readonly SR_RS = new Locale('sr_RS', 'Serbian (Serbia)');
  static readonly SH = new Locale('sh', 'Serbo-Croatian');
  static readonly SH_BA = new Locale('sh_BA', 'Serbo-Croatian (Bosnia & Herzegovina)');
  static readonly SN = new Locale('sn', 'Shona');
  static readonly SN_ZW = new Locale('sn_ZW', 'Shona (Zimbabwe)');
  static readonly II = new Locale('ii', 'Sichuan Yi');
  static readonly II_CN = new Locale('ii_CN', 'Sichuan Yi (China)');
  static readonly SI = new Locale('si', 'Sinhala');
  static readonly SI_LK = new Locale('si_LK', 'Sinhala (Sri Lanka)');
  static readonly SK = new Locale('sk', 'Slovak');
  static readonly SK_SK = new Locale('sk_SK', 'Slovak (Slovakia)');
  static readonly SL = new Locale('sl', 'Slovenian');
  static readonly SL_SI = new Locale('sl_SI', 'Slovenian (Slovenia)');
  static readonly SO = new Locale('so', 'Somali');
  static readonly SO_DJ = new Locale('so_DJ', 'Somali (Djibouti)');
  static readonly SO_ET = new Locale('so_ET', 'Somali (Ethiopia)');
  static readonly SO_KE = new Locale('so_KE', 'Somali (Kenya)');
  static readonly SO_SO = new Locale('so_SO', 'Somali (Somalia)');
  static readonly ES = new Locale('es', 'Spanish');
  static readonly ES_AR = new Locale('es_AR', 'Spanish (Argentina)');
  static readonly ES_BO = new Locale('es_BO', 'Spanish (Bolivia)');
  static readonly ES_IC = new Locale('es_IC', 'Spanish (Canary Islands)');
  static readonly ES_EA = new Locale('es_EA', 'Spanish (Ceuta & Melilla)');
  static readonly ES_CL = new Locale('es_CL', 'Spanish (Chile)');
  static readonly ES_CO = new Locale('es_CO', 'Spanish (Colombia)');
  static readonly ES_CR = new Locale('es_CR', 'Spanish (Costa Rica)');
  static readonly ES_CU = new Locale('es_CU', 'Spanish (Cuba)');
  static readonly ES_DO = new Locale('es_DO', 'Spanish (Dominican Republic)');
  static readonly ES_EC = new Locale('es_EC', 'Spanish (Ecuador)');
  static readonly ES_SV = new Locale('es_SV', 'Spanish (El Salvador)');
  static readonly ES_GQ = new Locale('es_GQ', 'Spanish (Equatorial Guinea)');
  static readonly ES_GT = new Locale('es_GT', 'Spanish (Guatemala)');
  static readonly ES_HN = new Locale('es_HN', 'Spanish (Honduras)');
  static readonly ES_MX = new Locale('es_MX', 'Spanish (Mexico)');
  static readonly ES_NI = new Locale('es_NI', 'Spanish (Nicaragua)');
  static readonly ES_PA = new Locale('es_PA', 'Spanish (Panama)');
  static readonly ES_PY = new Locale('es_PY', 'Spanish (Paraguay)');
  static readonly ES_PE = new Locale('es_PE', 'Spanish (Peru)');
  static readonly ES_PH = new Locale('es_PH', 'Spanish (Philippines)');
  static readonly ES_PR = new Locale('es_PR', 'Spanish (Puerto Rico)');
  static readonly ES_ES = new Locale('es_ES', 'Spanish (Spain)');
  static readonly ES_US = new Locale('es_US', 'Spanish (United States)');
  static readonly ES_UY = new Locale('es_UY', 'Spanish (Uruguay)');
  static readonly ES_VE = new Locale('es_VE', 'Spanish (Venezuela)');
  static readonly SW = new Locale('sw', 'Swahili');
  static readonly SW_KE = new Locale('sw_KE', 'Swahili (Kenya)');
  static readonly SW_TZ = new Locale('sw_TZ', 'Swahili (Tanzania)');
  static readonly SW_UG = new Locale('sw_UG', 'Swahili (Uganda)');
  static readonly SV = new Locale('sv', 'Swedish');
  static readonly SV_AX = new Locale('sv_AX', 'Swedish (Åland Islands)');
  static readonly SV_FI = new Locale('sv_FI', 'Swedish (Finland)');
  static readonly SV_SE = new Locale('sv_SE', 'Swedish (Sweden)');
  static readonly TL = new Locale('tl', 'Tagalog');
  static readonly TL_PH = new Locale('tl_PH', 'Tagalog (Philippines)');
  static readonly TA = new Locale('ta', 'Tamil');
  static readonly TA_IN = new Locale('ta_IN', 'Tamil (India)');
  static readonly TA_MY = new Locale('ta_MY', 'Tamil (Malaysia)');
  static readonly TA_SG = new Locale('ta_SG', 'Tamil (Singapore)');
  static readonly TA_LK = new Locale('ta_LK', 'Tamil (Sri Lanka)');
  static readonly TE = new Locale('te', 'Telugu');
  static readonly TE_IN = new Locale('te_IN', 'Telugu (India)');
  static readonly TH = new Locale('th', 'Thai');
  static readonly TH_TH = new Locale('th_TH', 'Thai (Thailand)');
  static readonly BO = new Locale('bo', 'Tibetan');
  static readonly BO_CN = new Locale('bo_CN', 'Tibetan (China)');
  static readonly BO_IN = new Locale('bo_IN', 'Tibetan (India)');
  static readonly TI = new Locale('ti', 'Tigrinya');
  static readonly TI_ER = new Locale('ti_ER', 'Tigrinya (Eritrea)');
  static readonly TI_ET = new Locale('ti_ET', 'Tigrinya (Ethiopia)');
  static readonly TO = new Locale('to', 'Tongan');
  static readonly TO_TO = new Locale('to_TO', 'Tongan (Tonga)');
  static readonly TR = new Locale('tr', 'Turkish');
  static readonly TR_CY = new Locale('tr_CY', 'Turkish (Cyprus)');
  static readonly TR_TR = new Locale('tr_TR', 'Turkish (Turkey)');
  static readonly UK = new Locale('uk', 'Ukrainian');
  static readonly UK_UA = new Locale('uk_UA', 'Ukrainian (Ukraine)');
  static readonly UR = new Locale('ur', 'Urdu');
  static readonly UR_IN = new Locale('ur_IN', 'Urdu (India)');
  static readonly UR_PK = new Locale('ur_PK', 'Urdu (Pakistan)');
  static readonly UG = new Locale('ug', 'Uyghur');
  static readonly UG_ARAB_CN = new Locale('ug_Arab_CN', 'Uyghur (Arabic, China)');
  static readonly UG_ARAB = new Locale('ug_Arab', 'Uyghur (Arabic)');
  static readonly UG_CN = new Locale('ug_CN', 'Uyghur (China)');
  static readonly UZ = new Locale('uz', 'Uzbek');
  static readonly UZ_AF = new Locale('uz_AF', 'Uzbek (Afghanistan)');
  static readonly UZ_ARAB_AF = new Locale('uz_Arab_AF', 'Uzbek (Arabic, Afghanistan)');
  static readonly UZ_ARAB = new Locale('uz_Arab', 'Uzbek (Arabic)', 'uz');
  static readonly UZ_CYRL_UZ = new Locale('uz_Cyrl_UZ', 'Uzbek (Cyrillic, Uzbekistan)');
  static readonly UZ_CYRL = new Locale('uz_Cyrl', 'Uzbek (Cyrillic)', 'uz');
  static readonly UZ_LATN_UZ = new Locale('uz_Latn_UZ', 'Uzbek (Latin, Uzbekistan)');
  static readonly UZ_LATN = new Locale('uz_Latn', 'Uzbek (Latin)', 'uz');
  static readonly UZ_UZ = new Locale('uz_UZ', 'Uzbek (Uzbekistan)');
  static readonly VI = new Locale('vi', 'Vietnamese');
  static readonly VI_VN = new Locale('vi_VN', 'Vietnamese (Vietnam)');
  static readonly CY = new Locale('cy', 'Welsh');
  static readonly CY_GB = new Locale('cy_GB', 'Welsh (United Kingdom)');
  static readonly FY = new Locale('fy', 'Western Frisian');
  static readonly FY_NL = new Locale('fy_NL', 'Western Frisian (Netherlands)');
  static readonly YI = new Locale('yi', 'Yiddish');
  static readonly YO = new Locale('yo', 'Yoruba');
  static readonly YO_BJ = new Locale('yo_BJ', 'Yoruba (Benin)');
  static readonly YO_NG = new Locale('yo_NG', 'Yoruba (Nigeria)');
  static readonly ZU = new Locale('zu', 'Zulu');
  static readonly ZU_ZA = new Locale('zu_ZA', 'Zulu (South Africa)');

  constructor(
    id: Id,
    name: string,
    readonly country = text(id).lower.last(2).toString(),
    private readonly lower = text(id).lower.trim.toString()
  ) {
    super(name, id);
  }

  static lookup(other: string): Optional<Locale> {
    return this.all<Locale>().first(l => l.equals(other));
  }

  equals<E extends Enum>(other: E | Id): other is E {
    return text(other).lower.trim.equals(this.lower);
  }
}
